import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';

import {
  AppBarDivider,
  AppBarFulfillmentMethodOptionLink
} from 'components/AppBar';
import { toTitleCase } from 'bento-ordering/base/utils/textUtils';
import { generatePath } from 'bento-ordering/utils/generatePath';
import { GROUP_ORDER } from 'bento-ordering/group_ordering/constants/entities';
import { openModal } from 'bento-ordering/base/actions/modal';
import {
  DESKTOP_CREATE_GROUP_ORDER_CTA_LABEL,
  GROUP_ORDER_APP_BAR_ICON
} from 'bento-ordering/group_ordering/constants/groupOrder';
import { useIsMobile } from 'styles/hooks/mediaQueries';
import {
  selectIsGroupOrderingEnabled,
  selectCartIsGroupOrder
} from 'bento-ordering/cart/selectors/index';

const AppBarGroupOrderCTA = ({ shouldDisplayFulfillmentOptions }) => {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const groupOrderingEnabled = useSelector(selectIsGroupOrderingEnabled);
  const isCartGroupOrder = useSelector(selectCartIsGroupOrder);

  const handleClick = () => {
    const path = generatePath(GROUP_ORDER, 'groupOrderSettings');

    dispatch(openModal());
    dispatch(push(path));
  };

  return (
    <>
      {!isCartGroupOrder &&
        !isMobile &&
        groupOrderingEnabled &&
        shouldDisplayFulfillmentOptions && (
          <Box
            display="flex"
            justifyContent="flex-end"
            flexDirection={{ xs: 'column', md: 'row' }}
            padding={{ xs: '10px 0', md: 'none' }}
          >
            <Box m={'0 4px 0 0'}>
              <AppBarFulfillmentMethodOptionLink
                isActive={false}
                fulfillmentOptionLabel={toTitleCase(
                  DESKTOP_CREATE_GROUP_ORDER_CTA_LABEL
                )}
                fulfillmentOptionIcon={GROUP_ORDER_APP_BAR_ICON}
                dataTestId={'create-group-order'}
                onClick={handleClick}
                iconDisplayMd={'flex'}
                iconInFrontOfLabel
              />
            </Box>
            <AppBarDivider />
          </Box>
        )}
    </>
  );
};

AppBarGroupOrderCTA.propTypes = {
  shouldDisplayFulfillmentOptions: PropTypes.bool.isRequired
};

export default AppBarGroupOrderCTA;
